import {useForm} from "../../../../hooks/useForm";
import baseUrl from "../../../../baseUrl";
import {requester} from "../../../../services/requester";
import {useEffect} from "react";
import {useCloseForm} from "../useCloseForm";

export const DrawingNew = ({
                               bullstat,
                               settlement_ekatte,
                               year,
                               onDrawingSubmit,
                               sumDrawings,
                               sumToDrawing,
                               cropsOptions
                           }) => {
    const request = requester();
    const closeForm = useCloseForm();
    const {values, changeHandler, onSubmitInitialValues} = useForm({
        mpo_number: 0,
        massif_number: 0,
        area: 0,
        crop: ""
    });

    useEffect(() => {
        window.scroll({
            top: document.body.offsetHeight,
            left: 0,
            behavior: 'smooth',
        });
    }, [])


    const onSubmit = async (e) => {
        e.preventDefault();

        const body = {
            bullstat: Number(bullstat),
            settlement_ekatte: settlement_ekatte,
            mpo_number: Number(values.mpo_number),
            massif_number: Number(values.massif_number),
            area: Number(values.area),
            crop: values.crop,
            year: Number(year)
        };

        try {
            await request.post(`${baseUrl()}/drawings`, body);
            onDrawingSubmit();
            closeForm();                     // Р2: обратно най-горе
        } catch (error) {
            alert(error.message || 'Възникна грешка при заявката.');
        }

        onSubmitInitialValues()
    }

    const availibilityToDrawing = sumToDrawing - sumDrawings;

    return (
        <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="massif_number" className="col-form-label">Масив</label>
                </div>
                <div className="col-2" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="massif_number" type="number" step="0.01" min="0" name="massif_number"
                           placeholder="Въведи масив"
                           value={values.massif_number}
                           onChange={changeHandler}/>
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="mpo_number" className="col-form-label">МПО номер</label>
                </div>
                <div className="col-2" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="mpo_number" type="number" step="0.01" min="0" name="mpo_number"
                           placeholder="Въведи номер"
                           value={values.mpo_number}
                           onChange={changeHandler}/>
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="area" className="col-form-label">Площ</label>
                </div>
                <div className="col-2" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="area" type="number" step="0.01" min="0" name="area"
                           placeholder="Въведи площи"
                           value={values.area}
                           onChange={changeHandler}/>
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="crop" className="col-form-label">Култура</label>
                </div>
                <div className="col-2" style={{marginLeft: "10px"}}>
                    <input className="col-11" type="search" list="new-crops-list" name="crop"
                           value={values.crop}
                           onChange={changeHandler}/>
                    <datalist id="new-crops-list">
                        {cropsOptions.map(d => <option key={d.id} value={d.value}/>)}
                    </datalist>
                </div>

            </div>
            <div className="row g-3 align-items-center">
                <div className="col-1">
                    <p className="col-form-label">Налично:</p>
                </div>
                {availibilityToDrawing > 0 ? (
                    <div className="col-5"
                         style={{color: "var(--app-info-fg)", fontWeight: "bold"}}>{availibilityToDrawing.toFixed(2)}</div>
                ) : (
                    <div className="col-5"
                         style={{color: "var(--app-danger-fg)", fontWeight: "bold"}}>{availibilityToDrawing.toFixed(2)}</div>
                )}

            </div>
            <button type="submit" className="btn btn-primary mt-3">Прибави</button>
        </form>
    );
};